<!-- 企业级-无人仓业务-配置设置 -->
<template>
  <div class="mainArea CConfigSetting">
      
      <div class="searchDiv mt20">
        <div>
          <div class="dib"><el-input placeholder="请输入预约人姓名" v-model="keyword.vname" clearable></el-input></div>
          <div class="dib"><el-input placeholder="请输入预约人电话" v-model="keyword.vphone" clearable></el-input></div>
          <!-- <div class="dib"><el-input placeholder="请输入子库" v-model="keyword.device_address" clearable></el-input></div> -->
          <el-button type="primary" @click="getWarehouse(1)">搜索</el-button>
        </div>
      </div>
      <div class="tabList">
        <el-table :data="configList" style="width: 100%" v-loading="tableLoading">
          <el-table-column type="index" label="序号" width="100"></el-table-column>
          <el-table-column prop="audit_name" label="预约名称"></el-table-column>
          <el-table-column label="授权设备">
            <template slot-scope="scope">
              <el-button type="text" @click="openDevice(scope.$index)">查看</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="device_type" label="设备类型"></el-table-column>
          <el-table-column prop="device_no_id" label="设备ID"></el-table-column>
          <el-table-column prop="device_name" label="设备名称"></el-table-column> -->
          <el-table-column label="预约时间段" width="300px">
            <template slot-scope="scope">
              <span>{{scope.row.start_time}}~{{scope.row.end_time}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="vname" label="预约人姓名"></el-table-column>
          <el-table-column prop="vphone" label="预约人手机号"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.vstatus == 0">待审核</span>
              <span v-else-if="scope.row.vstatus == 1">已通过</span>
              <span v-else>已拒绝</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div v-if="scope.row.vstatus == 0">
                <el-button type="text" @click="updateAudit(scope.row.id,'1')">同意</el-button>
                <el-button type="text" @click="updateAudit(scope.row.id,'-1')">拒绝</el-button>
              </div>
              <div v-else>/</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging" v-if="total>page">
        <el-pagination
          @current-change="CurrentChange"
          :current-page.sync="curr"
          :page-size="page"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <el-dialog title="查看授权设备" :visible.sync="deviceDio" width="600px">
        <div class="contDio">
          <el-table :data="deviceList" style="width: 100%">
            <el-table-column type="index" label="序号" width="100"></el-table-column>
            <el-table-column label="设备ID" prop="device_no_id"></el-table-column>
            <el-table-column label="设备类型" prop="device_type"></el-table-column>
            <el-table-column label="设备名称" prop="device_name"></el-table-column>
          </el-table>
        </div>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { bussinessApi } from "../../../../static/js/api.js"
  export default {
    name: 'CConfigSetting',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        keyword:{
          // device_id:'',
          vname:'',
          vphone:'',
        },

        configList:[],//审核记录列表
        tableLoading:false,
        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

        deviceDio:false,//查看授权设备弹窗
        deviceList:[],
      };
    },
    mounted(){
      
    },
    created: async function () {
      this.getWarehouse()
    },
    methods: {
      //打开查看授权设备
      openDevice(index){
        this.deviceList = this.configList[index].device_info
        this.deviceDio=true
      },
      //修改预约状态
      async updateAudit(id,status){
        let that = this;
        const data = {
          'id':id,
          'status':status
        }
        const res = await bussinessApi.auditorStatus(data)
        if(res.meta.code == 200){
          that.getWarehouse()
          showToast('修改成功！')
        }else{
          showToast(res.meta.message)
        }
      },
      //获取配置设置列表
      async getWarehouse(curr,limits){
        let that = this;
        this.tableLoading = true
        const data = {
          'page':curr ? curr : that.curr,//当前页
          'perPage': limits ? limits : that.page,//每页条数
          'vname':that.keyword.vname,//预约人姓名
          'vphone':that.keyword.vphone,//预约人手机号
        }
        let res = await bussinessApi.auditorDeviceList(data)
        if(res.meta.code == 200){
          that.configList = res.data.list
          that.total = parseInt(res.data.total)
          that.tableLoading = false
        }else{
          that.tableLoading = false
          showToast(res.meta.message)
        }
      },
      //分页
      CurrentChange(val) {
        this.curr = val
        // console.log(`当前页: ${val}`);
        this.getWarehouse(val)
      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      },
      
    }
  }
</script>

<style lang="scss">
.CConfigSetting{
  .previewDio{
    .tr{
      text-align: right;
      el-button{
        display: inline-block;
        line-height: 1;
        padding: 12px 20px;
        border:1px solid #DCDFE6;
        font-size: 14px;
        color: #606266;
        border-radius: 4px;
      }
    }
    .img{
      width: 200px;
      width: 200px;
      margin: 0px auto;
      padding: 20px;
      img{ width:100%; }
    }
  }
  
  .dib{
    display:inline-block;
  }
  .db{
    display:block;
  }
  .contDio{
    .el-select{ display:block;}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CMakeAppointment/CAuditRecord.vue